import { useState, useEffect } from "react";
import {
  useAbortedEffect,
  useHookForm,
  useConfirm,
} from "../../../../components/hooks";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import { ContractAPI } from "../../../../axios/api";

import { FormInputtextarea } from "../../../../components/formElement";
import { formatResData, checkFormUpdate } from "../../../../service/common";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModulePopSettingContractForm({
  prePopOption,
  closePrePop,
  setPreReload,
}) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState(null);
  // 表單欄位預設值
  const defaultValues = {
    question: "",
    answer: "",
    status: 1,
  };
  const { handleSubmit, setValue, reset, yup, setSchema, errors, setting } =
    useHookForm({
      defaultValues,
    });
  const { confirmOption, setConfirmOption, renderConfirm } = useConfirm();

  useEffect(() => {
    setSchema(
      yup
        .object({
          question: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  useAbortedEffect(
    (signal) => {
      dispatch(setProgress(true));

      let promise;

      if (prePopOption.data) {
        promise = ContractAPI.getQuestionAndAnswerMemberDetails({
          data: {
            id: prePopOption.data.id,
          },
          options: { signal },
        });
      } else {
        promise = ContractAPI.getQuestionAndAnswerMemberStatus0({
          options: { signal },
        });
      }

      promise.then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          let temp = formatResData(defaultValues, data ?? {});
          setApiData(data);
          reset(temp);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }
        dispatch(setProgress(false));
      });
    },
    [prePopOption.data]
  );

  const onSubmit = (submitData) => {
    setConfirmOption({
      setting: {
        target: document.getElementById(
          `button_confirm_${submitData.status === 0 ? "temp" : "save"}`
        ),
        message: `確認是否${submitData.status === 0 ? "存為草稿" : "送出"}?`,
        icon: "pi pi-exclamation-triangle",
        visible: !confirmOption.setting.visible,
        acceptLabel: "是",
        rejectLabel: "否",
        accept: () => saveData({ submitData }),
        reject: () => null,
      },
      reOpen: confirmOption.setting.visible,
    });
  };

  const saveData = ({ submitData }) => {
    dispatch(setProgress(true));

    let isAdd = !apiData,
      jsonData = formatResData(defaultValues, submitData);

    if (!checkFormUpdate(jsonData, apiData ?? {})) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      closePrePop({ type: "form" });
      return;
    }

    let promise;
    if (isAdd) {
      // 新增
      promise = ContractAPI.setQuestionAndAnswerMember({
        data: jsonData,
      });
    } else {
      // 修改
      promise = ContractAPI.updateQuestionAndAnswerMember({
        data: {
          ...jsonData,
          id: apiData.id,
        },
      });
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary:
              submitData.status === 1
                ? "您的提問已送出，我們會盡快回覆您"
                : "已存為草稿",
            detail: "",
          })
        );
        closePrePop({ type: "form" });
        setPreReload((state) => ({ ...state, list: true }));
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `送出失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      {renderConfirm}

      <div className="px-4">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="question"
              className={classNames(
                { "p-error": errors.question },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              問題
            </label>
            <div className="col-12 sm:col-10">
              <FormInputtextarea
                setting={setting}
                data={{
                  name: "question",
                  rows: 15,
                  placeholder: "請輸入問題",
                  disabled: prePopOption.data,
                }}
              />
            </div>
          </div>

          {prePopOption.data && (
            <div className="flex flex-column align-items-start sm:flex-row field col-12">
              <label
                htmlFor="answer"
                className={classNames(
                  { "p-error": errors.answer },
                  "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
                )}
              >
                回覆
              </label>
              <div className="col-12 sm:col-10">
                <FormInputtextarea
                  setting={setting}
                  data={{
                    name: "answer",
                    rows: 15,
                    disabled: true,
                  }}
                />
              </div>
            </div>
          )}

          <div className="col-12 text-right">
            <Button
              type="button"
              label={prePopOption.data ? "關閉" : "取消"}
              className={classNames("p-button-secondary ml-auto mr-2 px-3", {
                "p-button-outlined": !prePopOption.data,
                "mr-2": prePopOption.data,
              })}
              onClick={() => closePrePop({ type: "form" })}
            />
            {!prePopOption.data && (
              <>
                <Button
                  id="button_confirm_temp"
                  type="button"
                  label="存草稿"
                  className="p-button-danger mr-2 px-3"
                  onClick={() => {
                    setValue("status", 0);
                    document.getElementById("submitBtn").click();
                  }}
                />
                <Button
                  id="button_confirm_save"
                  type="button"
                  label="送出"
                  className="mr-2 px-3"
                  onClick={() => {
                    setValue("status", 1);
                    document.getElementById("submitBtn").click();
                  }}
                />
                <Button
                  id="submitBtn"
                  type="submit"
                  label="儲存"
                  className="mr-2 px-3 hidden"
                />
              </>
            )}
          </div>
        </form>
      </div>
    </>
  );
}
